export type CalendarCrewKind = 'internal'|'external'|'staff'|'unassigned';

export type CalendarScheduleEvent = {
  id:string;
  date:string;
  job_ref:string;
  label:string;
  crew:string|null;
  task:string|null;
  completed_at:string|null;
  crew_kind:CalendarCrewKind;
};

export type CalendarJobDay = {
  id:string;
  date:string;
  job:string;
  label:string;
  kind:CalendarCrewKind|'mixed';
  installers:Array<{
    id:string;
    name:string|null;
    task:string|null;
    completedAt:string|null;
    kind:CalendarCrewKind;
  }>;
};

/**
 * The schedule is correctly stored as one row per assignee + Sydney day. The
 * office calendar is job work, though: one Job on one date must occupy one card,
 * with the attending installers expanded only in the day detail.
 */
export function groupCalendarJobDays(events:CalendarScheduleEvent[]):CalendarJobDay[] {
  const grouped=new Map<string,CalendarJobDay>();
  for(const event of events){
    const key=`${event.date}\u0000${event.job_ref}`;
    let day=grouped.get(key);
    if(!day){
      day={id:`job:${event.job_ref}:${event.date}`,date:event.date,job:event.job_ref,label:event.label,kind:event.crew_kind,installers:[]};
      grouped.set(key,day);
    }
    day.installers.push({id:event.id,name:event.crew,task:event.task,completedAt:event.completed_at,kind:event.crew_kind});
    if(day.kind!==event.crew_kind)day.kind='mixed';
  }
  return [...grouped.values()].sort((a,b)=>a.date.localeCompare(b.date)||a.job.localeCompare(b.job));
}
